import { Component, OnInit, Input } from '@angular/core';
import { FormatoAsistencialEntity, ServicioFormatoAsistencialService, FiltrosFormatoAsistencialEntity, TratamientoAsistencialEntity } from 'src/app/services/servicio-formato-asistencial.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-evoluciones',
  templateUrl: './evoluciones.component.html',
  styleUrls: ['./evoluciones.component.css']
})
export class EvolucionesComponent implements OnInit {

  @Input() datosEncabezado: FormatoAsistencialEntity;
  @Input() filtros: FiltrosFormatoAsistencialEntity;

  evoluciones: TratamientoAsistencialEntity[] = [];

  constructor( private servicioFormato: ServicioFormatoAsistencialService) { }

  ngOnInit() {
    this.getEvoluciones();
  }

  async getEvoluciones() {
    const request = await this.servicioFormato.getEvoluciones(this.filtros.codigoBaseDatos, this.filtros.tta);
    if (request) {
      request.subscribe((ttas: TratamientoAsistencialEntity[]) => {
        this.evoluciones = ttas;
      }, (err: HttpErrorResponse) => {
        this.evoluciones = [];
        console.error('EvolucionesComponent.getEvoluciones()', err);
      })
    }
  }

}
